"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPurchaseMotionData = exports.fetchMerchandiseCatalog = void 0;

var _ActionTypes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/ActionTypes"));

var _dispatchAndThrowError = require("pricing-pages-unified-ui/utils/dispatchAndThrowError");

var _getMerchandise = _interopRequireDefault(require("self-service-api/api/getMerchandise"));

var fetchMerchandiseCatalog = function fetchMerchandiseCatalog() {
  return function (dispatch) {
    dispatch({
      type: _ActionTypes.default.MERCHANDISE_REQUESTED
    });
    return (0, _getMerchandise.default)('merchandise').then(function (merchandiseMap) {
      dispatch({
        type: _ActionTypes.default.MERCHANDISE_RECEIVED,
        payload: merchandiseMap
      });
    }).catch(function (error) {
      (0, _dispatchAndThrowError.dispatchAndThrowError)({
        dispatch: dispatch,
        type: _ActionTypes.default.MERCHANDISE_FAILED,
        error: error
      });
    });
  };
};

exports.fetchMerchandiseCatalog = fetchMerchandiseCatalog;

var fetchPurchaseMotionData = function fetchPurchaseMotionData(getPurchaseMotions) {
  return function (dispatch) {
    dispatch({
      type: _ActionTypes.default.PURCHASE_MOTION_DATA_REQUESTED
    });
    return getPurchaseMotions().then(function (data) {
      var _data$metadata = data.metadata,
          customerCurrencyCode = _data$metadata.customerCurrencyCode,
          parcels = _data$metadata.parcels,
          subscriptionTerms = _data$metadata.subscriptionTerms,
          merchandiseIdsTreatedAsOwned = _data$metadata.merchandiseIdsTreatedAsOwned,
          purchaseMotionsByLocation = data.purchaseMotionsByLocation;
      dispatch({
        type: _ActionTypes.default.CUSTOMER_CURRENCY_CODE_RECEIVED,
        payload: customerCurrencyCode
      });
      dispatch({
        type: _ActionTypes.default.SUBSCRIPTION_TERMS_RECEIVED,
        payload: subscriptionTerms
      });
      dispatch({
        type: _ActionTypes.default.PURCHASE_MOTIONS_BY_LOCATION_RECEIVED,
        payload: purchaseMotionsByLocation
      });
      dispatch({
        type: _ActionTypes.default.MERCHANDISE_IDS_TREATED_AS_OWNED_RECEIVED,
        payload: merchandiseIdsTreatedAsOwned
      });
      dispatch({
        type: _ActionTypes.default.PARCELS_RECEIVED,
        payload: parcels
      });
      dispatch({
        type: _ActionTypes.default.PURCHASE_MOTION_DATA_SUCCEEDED
      });
    }).catch(function (error) {
      (0, _dispatchAndThrowError.dispatchAndThrowError)({
        dispatch: dispatch,
        type: _ActionTypes.default.PURCHASE_MOTION_DATA_FAILED,
        error: error
      });
    });
  };
};

exports.fetchPurchaseMotionData = fetchPurchaseMotionData;